import { createContext, useContext } from "react";

/** Interface */
interface IProjectContactsContext {
	projectId: string;
}

/** Context */
export const ProjectContactsContext = createContext<IProjectContactsContext>(
	{} as IProjectContactsContext,
);

/** Hooks */
export function useProjectContactsContext() {
	return useContext(ProjectContactsContext);
}
